import { render, staticRenderFns } from "./PillarSection.vue?vue&type=template&id=97e88d1c&scoped=true&"
import script from "./PillarSection.vue?vue&type=script&lang=js&"
export * from "./PillarSection.vue?vue&type=script&lang=js&"
import style0 from "./PillarSection.vue?vue&type=style&index=0&id=97e88d1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e88d1c",
  null
  
)

export default component.exports